import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      if (state?.user?.length > 0) {
        state.user = [];
      }

      state.user.push(action.payload);
    },
    logOut: (state, action) => {
      return {
        ...state,
        user: [],
      };
    },
  },
});

export const { login, logOut } = userSlice.actions;

export const selectUser = (state) => state?.users?.user;
export default userSlice.reducer;
